"use client";

import { useState, useEffect } from "react";
import Cookies from "js-cookie";

function useStoredState<T>(
  key: string | undefined,
  initialValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [val, setVal] = useState<T>(() => {
    if (!key || typeof window === "undefined") return initialValue;
    try {
      const stored = localStorage.getItem(key);
      if (stored) return JSON.parse(stored) as T;
      // Fall back to cookie for backwards compatibility
      const cookie = Cookies.get(key);
      if (cookie) return JSON.parse(cookie) as T;
    } catch {
      // ignore parse errors
    }
    return initialValue;
  });

  useEffect(() => {
    if (!key || typeof window === "undefined") return;
    localStorage.setItem(key, JSON.stringify(val));
  }, [key, val]);

  return [val, setVal];
}

export default useStoredState;
